import { getGatekeeperFeatures, initFeatures } from '@luna/gatekeeper';
import type { RetailFeatures } from '@retail/gatekeeper';

import { getCountryFeatures } from './countryFeatures';

export const getFeatures = (): RetailFeatures => {
    const features = getGatekeeperFeatures<RetailFeatures>();

    if (features) {
        return features;
    }

    return initFeatures(getCountryFeatures());
};
